import React from "react";
import {
  LuInstagram,
  LuFacebook,
  LuTwitter,
  LuLinkedin,
  LuYoutube,
} from "react-icons/lu";
import { IconButton } from "@chakra-ui/react";

function SocialDisplay() {
  const socials = [
    {"name": "Instagram", "icon": <LuInstagram />, "url": "https://www.instagram.com/fogsolution/"},
    {"name": "Facebook", "icon": <LuFacebook />, "url": "https://www.facebook.com/fogsolution/"},
    {"name": "Twitter", "icon": <LuTwitter />, "url": "https://www.twitter.com/fogsolution/"},
    {"name": "Linkedin", "icon": <LuLinkedin />, "url": "https://www.linkedin.com/company/fogsolution/"},
    {"name": "Youtube", "icon": <LuYoutube />, "url": "https://www.youtube.com/channel/UC_x5XG1OV2P63Sny_3o8A7w"},
  ];
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: "20px",
        flexDirection: "row",
        marginBottom: "50px"
      }}
    >
        {socials.map((social) => (
            <IconButton width="50px" height="50px" key={social.name} asChild variant="outline" size="xl" >
                <a href={social.url}>
                    {social.icon}
                </a>
            </IconButton>
        ))}
    </div>
  );
}

export default SocialDisplay;
